import React, { Fragment } from 'react';
import { Container, Row, Col } from 'reactstrap';

import env from '../../env/src_config';

const Footer = () => {
    return (
        <Fragment>
            <footer className="footer">
                <Container fluid={true}>
                    <Row>
                        <Col md="12" className="footer-copyright text-center">
                            <p className="mb-0">{"Copyright 2023 © ERP SYSTEM by " + env?.footer_name}</p>
                        </Col>
                    </Row>
                </Container>
            </footer>
        </Fragment>
    );
}

export default Footer;
